module.exports = __webpack_public_path__ + "static/media/00.7d1bf76b.jpg";